import { memo, useCallback, useEffect, useState } from "react";
import { authorize, verifyToken } from "../request/authorize";
import React from "react";
import { Button, Input, Stack, Typography } from "@mui/material";
import { generateMD5Hash } from "../utils/md5";
export const Authorize = memo(({ children }) => {
    const [authorized, setAuthorized] = useState(false);
    const inputRef = React.useRef(null);
    useEffect(() => {
        try {
            verifyToken().then((result) => {
                setAuthorized(result);
            });
        }
        catch (e) {
            console.error(e);
        }
    }, []);
    const handleSubmit = useCallback(() => {
        var _a;
        try {
            const password = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value;
            if (password) {
                authorize(generateMD5Hash(password)).then((result) => {
                    setAuthorized(result);
                });
            }
        }
        catch (e) {
            console.error(e);
        }
    }, []);
    return authorized ? (React.createElement(React.Fragment, null, children)) : (React.createElement(Stack, { direction: "column", spacing: 2, alignItems: "center" },
        React.createElement(Typography, { variant: "h4" }, "Please input your key"),
        React.createElement(Input, { type: "password", inputRef: inputRef }),
        React.createElement(Button, { onClick: handleSubmit, sx: { textTransform: "none" } }, "Submit")));
});
Authorize.displayName = "Authorize";
